<template>
  <v-text-field
      dense
      rounded
      filled
      v-model="searchField"
      prepend-inner-icon="mdi-magnify"
      :label="$t('actions.search-three-dots')"
      single-line
      hide-details
      append-icon="mdi-close"
      @click:append="searchField = ''"
  ></v-text-field>
</template>

<script>
export default {
  name: 'PageSearch',
  props: ['search'],
  data () {
    return {
      searchField: this.search,
    }
  },
  watch: {
    search (value) {
      this.searchField = value
    },
    searchField () {
      this.$emit('changed', this.searchField)
    }
  }
}
</script>

<style scoped>

</style>